import { templateDataSource } from '@@modules/admin/api/template';
import type { VisualTheme } from '@inwink/entities/visualtheme';

export interface IAlertBannerConfig {
    enabled?: boolean;
    level?: number;
    text?: VisualTheme.IAppLabel;
}

export const queryAlertBannerTemplate = async (): Promise<any> => {
    const ds = templateDataSource();
    const res = await ds.query({
        filters: {
            $and: [
                { templateTarget: { $equal: 'alertbanner' } },
                { targetApplication: { $equal: 'bo' } }
            ]
        }
    });
    return res?.data?.[0] || null;
};

export const fetchAlertBannerConfig = async (): Promise<IAlertBannerConfig | null> => {
    const tpl = await queryAlertBannerTemplate();
    if (!tpl) {
        return null;
    }
    return (tpl.template?.config || {}) as IAlertBannerConfig;
};
